import {register, CloudObject, defineProperty} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class ColumnsDataType extends CloudObject {
    /**
     * Creates an instance of ColumnsDataType.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(ColumnsDataType);
    }

    /**
     * @return {string}
     */
    getColumnName() {
        return this.get(ColumnsDataType.columnNameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeColumnName($) {
        return this.observe($, ColumnsDataType.columnNameProp);
    }

    /**
     * @return {string}
     */
    getTableName() {
        return this.get(ColumnsDataType.tableNameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeTableName($) {
        return this.observe($, ColumnsDataType.tableNameProp);
    }

    /**
     * @return {string}
     */
    getType() {
        return this.get(ColumnsDataType.typeProp);
    }

    /**
     * @return {string}
     */
    getColumnDisplayName() {
        return this.get(ColumnsDataType.columnDisplayNameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeType($) {
        return this.observe($, ColumnsDataType.typeProp);
    }

    /**
     * @return {number}
     */
    getWidth() {
        return this.get(ColumnsDataType.widthProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<number>}
     */
    observeWidth($) {
        return this.observe($, ColumnsDataType.widthProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setColumnName(transaction, instance, value) {
        transaction.update(instance, ColumnsDataType.columnNameProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setTableName(transaction, instance, value) {
        transaction.update(instance, ColumnsDataType.tableNameProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setType(transaction, instance, value) {
        transaction.update(instance, ColumnsDataType.typeProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {number} value
     */
    static setWidth(transaction, instance, value) {
        transaction.update(instance, ColumnsDataType.widthProp, value);
    }
}

// Hardcoded tags
register('0190ede34886dfcf87c7', ColumnsDataType);
ColumnsDataType.columnNameProp = defineProperty('0190ede38f48778253ef');
ColumnsDataType.tableNameProp = defineProperty('0190ede39a83b80b1b43');
ColumnsDataType.typeProp = defineProperty('0190ede3a4d4385ecb8f');
ColumnsDataType.widthProp = defineProperty('0190ede3c6f2fa79cc17');
ColumnsDataType.columnDisplayNameProp = defineProperty('0190ede384b10322740c');
